import { useTranslation } from 'react-i18next'

import Dialog from 'components/Dialog'
import { SaveButton, useCommonFormContextProps } from 'components/Form'
import { EndAbTestContext, EndAbTestContextType } from './context/EndAbTestContext'
import { EndAbTestForm } from './forms/EndAbTestForm'
import { EndAbTestDialogProps } from './types'

export const EndAbTestDialog = ({
  abTest,
  isOpen,
  setOpen,
}: EndAbTestDialogProps): React.JSX.Element => {
  const { t } = useTranslation('features/abTests', { keyPrefix: 'endTest.form' })
  const { t: tCommon } = useTranslation('common')
  const commonContextProps = useCommonFormContextProps({
    formId: 'end-ab-test-dialog',
    touched: true,
  })

  const endAbTestContext: EndAbTestContextType = {
    ...commonContextProps,
    abTest,
    setOpen,
  }

  return (
    <EndAbTestContext.Provider value={endAbTestContext}>
      <EndAbTestContext.Consumer>
        {(ctxProps: EndAbTestContextType): React.JSX.Element => (
          <Dialog
            actions={
              <SaveButton
                text={tCommon('actions.confirm')}
                {...ctxProps}
              />
            }
            content={<EndAbTestForm />}
            title={t('title', { domainName: abTest.domain.name })}
            {...{ isOpen, setOpen }}
          />
        )}
      </EndAbTestContext.Consumer>
    </EndAbTestContext.Provider>
  )
}
